class CareProduct extends HTMLElement {
  options = [];
  currentId;
  variants;
  careList = [];
  isSelected = false;
  isShow = false;

  constructor() {
    super();
    this.init();
  }

  init() {
    // 初始化数据
    this.initData();
    // 初始化变体选择监听
    this.initVariantHandler();
    // 初始化详情按钮
    this.initDetailButton();
  }

  initData() {
    try {
      this.options = this.dataset.options
        ? JSON.parse(this.dataset.options)
        : [];
      this.variants = this.dataset.variants
        ? JSON.parse(this.dataset.variants)
        : [];
      this.currentId = this.dataset.currentVariant || null;
      // 修改: 使用更精确的布尔值转换逻辑
      this.isShow = this.dataset.show === 'true';
      
    } catch (error) {
      console.error('初始化错误', error);
    }
  }


  initVariantHandler() {
    // this.querySelector('input[value="no"]').checked = true;

    const variantSelects = this.querySelectorAll(
      '.version-radio-group input[type="radio"]'
    );
    // const variantSelects = this.querySelectorAll(
    //   'input[name="version-radio-option"]'
    // );
    variantSelects.forEach((option) => {
      option.addEventListener('change', (event) => {
        this.handleVariantChange(event);
      });
    });

  
  }

  initDetailButton() {
    const detailButton = this.querySelector('.show-detail');
    if (detailButton) {
      detailButton.addEventListener('click', (event) => {
        event.stopPropagation();
        const dialog = this.querySelector('product-detail-hovercare-dialog');
        if (dialog) dialog.showModal();
      });
    }
  }

  handleVariantChange(event) {
    const position = parseInt(event.target.dataset.position) - 1;
    if (isNaN(position)) return;

    this.options[position] = event.target.value;
    const matchedVariant = this.variants.find(
      (variant) =>
        JSON.stringify(variant.options) === JSON.stringify(this.options)
    );

    if (matchedVariant) {
      this.isSelected = true;
      this.updateVariant(matchedVariant);
    } else {
      this.isSelected = false;
      const defaultVariant = this.variants[0]
      defaultVariant && this.updateVariant(defaultVariant);
      // this.updateBarPrice();
    }
  }

  updateVariant(variant) {
    this.currentId = variant.id;
    this.updateImage(variant);
    this.updatePrice();
    this.updateDialogInfo(variant);
  }

  updateImage(variant) {
    const image = this.querySelector('.image');
    if (image && variant.featured_image) {
      image.src = `${variant.featured_image.src}&width=200`;
      image.srcset = `${variant.featured_image.src}&width=200`;
    }
  }

  updatePrice() {
    const priceTag = Array.from(this.querySelectorAll('.price'));
    priceTag.forEach((tag, index) => {
      if (tag.dataset.productId == this.currentId) {
        tag.classList.remove('tw-hidden');
        tag.classList.add('current-price');
      } else {
        tag.classList.add('tw-hidden');
        tag.classList.remove('current-price');
      }
    });

    // 更新购买栏价格
    this.updateBarPrice();
  }
  updateBarPrice() {
    const bar = document.querySelector('buy-bottom-bar');
    if (bar) {
      bar.updatePrice();
    }
  }

  updateDialogInfo(variant) {
    const dialog = this.querySelector('product-detail-hovercare-dialog');
    if (!dialog) return;

    console.log('updateDialogInfo-variant', variant);

    const dialogPrice = dialog.querySelector('[data-product-variant-price]');

    if (dialogPrice)
      dialogPrice.innerHTML = this.moneyWithoutTrailingZeros(
        variant.price,
        this.dataset.cartCurrency
      );

    if (variant.price === variant.compare_at_price) {
      // hide compare at price & discount percentage
      const dialogCompareAtPrice = dialog.querySelector(
        '[data-product-variant-compare-at-price]'
      );
      const dialogDiscountPercentage = dialog.querySelector(
        '[data-product-variant-discount-percentage]'
      );
      if (dialogCompareAtPrice) dialogCompareAtPrice.classList.add('tw-hidden');
      if (dialogDiscountPercentage)
        dialogDiscountPercentage.classList.add('tw-hidden');
    } else {
      // show compare at price & discount percentage
      const dialogCompareAtPrice = dialog.querySelector(
        '[data-product-variant-compare-at-price]'
      );
      const dialogDiscountPercentage = dialog.querySelector(
        '[data-product-variant-discount-percentage]'
      );
      if (dialogCompareAtPrice) {
        dialogCompareAtPrice.classList.remove('tw-hidden');
        dialogCompareAtPrice.innerHTML = this.moneyWithoutTrailingZeros(
          variant.compare_at_price,
          this.dataset.cartCurrency
        );
      }
      if (dialogDiscountPercentage) {
        dialogDiscountPercentage.classList.remove('tw-hidden');
        const discountPercentage =
          ((variant.compare_at_price - variant.price) /
            variant.compare_at_price) *
          100;
        dialogDiscountPercentage.innerHTML =
          discountPercentage.toFixed(0) + '%';
      }
    }
  }

  getNumber() {
    const quantityInput = this.querySelector('.product-counter input');
    return quantityInput ? quantityInput.value : '1';
  }

  moneyWithoutTrailingZeros(cents, currency) {
    const money = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency || 'USD',
    }).format(cents / 100);
    return money.replace(/\.00$/, '');
  }
 
}

customElements.define('care-product', CareProduct);

class HovercareDialog extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const closeBtn = this.querySelector('#close-modal-btn');
    closeBtn.addEventListener('click', () => {
      this.closeModal();
    });

  }


  showModal() {
    console.log('showModal ----- ')
    const modal = this.querySelector('#hovercare-choosemodal');
    const mask = this.querySelector('#hovercare-choose-modalMask');
    const body = document.body;
    modal.style.display = 'block';
    mask.style.display = 'block';
    setTimeout(() => {
      modal.classList.add('show');
    }, 10);
    body.classList.add('modal-open');

  }
  closeModal() {
    this.chooseId = '';
    const modal = this.querySelector('#hovercare-choosemodal');
    const mask = this.querySelector('#hovercare-choose-modalMask');
    const body = document.body;
    modal.classList.remove('show');
    setTimeout(() => {
      modal.style.display = 'none';
      mask.style.display = 'none';
    }, 300);
    body.classList.remove('modal-open');
  }
 


}


customElements.define('product-detail-hovercare-dialog', HovercareDialog);

